import EmailServiceParameter from '@/views/shop/tabs/ServicesParameters/services/EmailServiceParameter.vue';
import SmsServiceParameter from '@/views/shop/tabs/ServicesParameters/services/SmsServiceParameter.vue';
import FacebookServiceParameter from '@/views/shop/tabs/ServicesParameters/services/FacebookServiceParameter.vue';
import PushNotificationServiceParameter from '@/views/shop/tabs/ServicesParameters/services/PushNotificationServiceParameter/PushNotificationServiceParameter.vue';
import SocialNetworkServiceParameter from '@/views/shop/tabs/ServicesParameters/services/SocialNetworkServiceParameter.vue';
import ImportantLinksServiceParameter from '@/views/shop/tabs/ServicesParameters/services/ImportantLinksServiceParameter.vue';
import VoucherServiceParameter from '@/views/shop/tabs/ServicesParameters/services/VoucherServiceParameter.vue';
import AIServiceParameter from '@/views/shop/tabs/ServicesParameters/services/AIServiceParameter.vue';
import WhatsappBusinessServiceParameter from '@/views/shop/tabs/ServicesParameters/services/WhatsappBusinessServiceParameter.vue';
import RcsServiceParameter from '@/views/shop/tabs/ServicesParameters/services/RcsServiceParameter.vue';
import SubscriptionPageServiceParameter from '@/views/shop/tabs/ServicesParameters/services/SubscriptionPageServiceParameter.vue';
import ProductRecommendationServiceParameter from '@/views/shop/tabs/ServicesParameters/services/ProductRecommendationServiceParameter.vue';
import SalesAssociationServiceParameter from '@/views/shop/tabs/ServicesParameters/services/SalesAssociationServiceParameter.vue';

const ComponentsServiceParameters = {
  EmailServiceParameter,
  SmsServiceParameter,
  FacebookServiceParameter,
  PushNotificationServiceParameter,
  SocialNetworkServiceParameter,
  ImportantLinksServiceParameter,
  VoucherServiceParameter,
  AIServiceParameter,
  WhatsappBusinessServiceParameter,
  RcsServiceParameter,
  SubscriptionPageServiceParameter,
  ProductRecommendationServiceParameter,
  SalesAssociationServiceParameter,
};

export default ComponentsServiceParameters;
